module.exports = __webpack_public_path__ + "static/media/ambulance.67cfd352.svg";